export const activated_features = ['address_fields_gender_as_radio_button']
